import styled from "styled-components";
import { colors, radius } from "../../../styles/theme/tokens";

export const Tabs = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  align-items: center;
`;

export const TabBtn = styled.button`
  border: 1px solid ${(p) => (p.$active ? colors.brand : colors.line)};
  background: ${(p) => (p.$active ? colors.brandSoft : colors.surface)};
  color: ${(p) => (p.$active ? colors.brandDeep : colors.ink)};
  border-radius: ${radius.pill};
  padding: 7px 14px;
  font: inherit;
  font-weight: 800;
  font-size: 0.88rem;
  cursor: pointer;
  white-space: nowrap;
  & > small { font-weight: 700; color: ${colors.muted}; margin-left: 4px; }
`;

export const Spacer = styled.div`
  flex: 1;
`;

export const Kpis = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  @media (max-width: 1000px) { grid-template-columns: repeat(2, 1fr); }
`;

export const Kpi = styled.div`
  background: ${(p) => (p.$tone === "bad" ? colors.dangerSoft : p.$tone === "good" ? colors.successSoft : colors.brandSoft)};
  border-radius: ${radius.md};
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  b { font-size: 1.7rem; font-weight: 800; color: ${(p) => (p.$tone === "bad" ? colors.danger : colors.brandDark)}; line-height: 1.15; }
  span { font-size: 0.8rem; color: ${colors.muted}; font-weight: 700; }
  em { font-style: normal; font-size: 0.8rem; color: ${colors.muted}; }
`;

export const Weeks = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 8px;
  align-items: end;
  @media (max-width: 700px) { grid-template-columns: repeat(4, 1fr); }
`;

export const Week = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  font-size: 0.75rem;
  color: ${colors.muted};
  .bar { width: 100%; height: 90px; display: flex; align-items: flex-end; background: ${colors.bg}; border-radius: ${radius.sm}; position: relative; overflow: hidden; }
  .bar > i { display: block; width: 100%; background: ${(p) => (p.$low ? colors.pink : colors.brand)}; border-radius: ${radius.sm} ${radius.sm} 0 0; }
  .bar > s { position: absolute; left: 0; right: 0; border-top: 2px dashed ${colors.amberDeep}; }
  b { color: ${colors.ink}; font-size: 0.9rem; }
`;

export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 12px;
`;

export const PostCard = styled.a`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px;
  border-radius: ${radius.md};
  background: ${colors.bg};
  color: ${colors.ink};
  text-decoration: none;
  border: 1px solid transparent;
  &:hover { border-color: ${colors.brand}; }
  .top { display: flex; justify-content: space-between; gap: 8px; font-size: 0.8rem; color: ${colors.muted}; font-weight: 700; }
  .cap { font-size: 0.86rem; line-height: 1.35; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; }
  .nums { display: flex; gap: 10px; font-size: 0.8rem; color: ${colors.muted}; flex-wrap: wrap; }
  .nums b { color: ${colors.ink}; }
`;

export const Ratio = styled.span`
  display: inline-block;
  padding: 1px 7px;
  border-radius: ${radius.pill};
  font-size: 0.75rem;
  font-weight: 800;
  white-space: nowrap;
  background: ${(p) => (p.$v >= 2.5 ? colors.successSoft : p.$v >= 1 ? colors.brandSoft : colors.dangerSoft)};
  color: ${(p) => (p.$v >= 2.5 ? colors.success : p.$v >= 1 ? colors.brandDeep : colors.danger)};
`;

export const Cap = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 420px;
  min-width: 180px;
`;

export const Idea = styled.div`
  border: 1px solid ${colors.line};
  border-left: 4px solid ${(p) => (p.$p === 1 ? colors.pink : p.$p === 3 ? colors.line : colors.brand)};
  border-radius: ${radius.md};
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: ${colors.surface};
  h4 { margin: 0; font-size: 1rem; font-weight: 800; }
  .hook { background: ${colors.amberSoft}; border-radius: ${radius.sm}; padding: 8px 10px; font-size: 0.9rem; }
  .meta { display: flex; gap: 6px; flex-wrap: wrap; align-items: center; }
  .why { font-size: 0.86rem; color: ${colors.muted}; }
  .actions { display: flex; gap: 6px; flex-wrap: wrap; }
  details summary { cursor: pointer; font-weight: 700; font-size: 0.86rem; color: ${colors.brandDeep}; }
  details div { white-space: pre-wrap; font-size: 0.88rem; margin-top: 6px; line-height: 1.45; }
  a { color: ${colors.brandDeep}; }
`;

export const Md = styled.div`
  font-size: 0.92rem;
  line-height: 1.5;
  h1, h2, h3, h4 { margin: 14px 0 6px; font-size: 1rem; font-weight: 800; }
  ul { margin: 4px 0; padding-left: 20px; }
  li { margin: 2px 0; }
  p { margin: 6px 0; }
  a { color: ${colors.brandDeep}; }
`;

export const TextArea = styled.textarea`
  width: 100%;
  box-sizing: border-box;
  font: inherit;
  padding: 10px 12px;
  border-radius: ${radius.sm};
  border: 1px solid ${colors.line};
  resize: vertical;
`;
